import PhoneDetails from './PhoneDetailsContainer';
import PhoneDetailsCardComponent from './PhoneDetailsCardComponent';

export default { PhoneDetails, PhoneDetailsCardComponent };
